const emptyState = { pendingId: '', approvedId: '' };

export default function ContractSecurityReviewReducer(state = emptyState, action) {
  switch (action.type) {
    case 'REQUEST_CONTRACT_SECURITY_REVIEW':
      return { pendingId: action.payload, approvedId: '' };
    case 'ANSWER_CONTRACT_SECURITY_REVIEW':
      if (state.pendingId !== action.payload.id) return state;
      return { pendingId: '', approvedId: action.payload.continueAnyway ? state.pendingId : '' };
    default:
      return state;
  }
}
